import type { ComponentProps } from "react";

import { cn } from "shared/utils/cn";

export const Description = ({ className, ...props }: ComponentProps<"p">) => {
  return (
    <p
      className={cn(
        "text-pale-grey text-[13px] leading-4 tracking-[0.08px] uppercase",
        className
      )}
      {...props}
    />
  );
};
